<template>
    <div class="review-analysis">
        <OptionCard :info="{ title: '买家评论', desc: `${pageParams.startDateTime}~${pageParams.endDateTime}`, label: pageParams.dateLabel}"
                    :body-style="{padding: '0 0 0 20px'}" :actions="['refresh']" @refresh="refresh">
            <OptionCard :info="{ title: '评星分析'}" :actions="[]" noBorder :areaLevel="2" :body-style="{paddingBottom: 0}">
                <el-row type="flex" :gutter="10">
                    <el-col :span="12">
                        <OptionCard  hide-header :actions="[]" :body-style="{}" style="height: 100%; box-sizing: border-box;">
                            <ve-histogram v-loading="load.star" height="300px" :data-empty="commentBarChartData.empty" :data="commentBarChartData.data" :settings="commentBarChartData.settings" :extend="commentBarChartData.options" key="commentBarChartData"></ve-histogram>
                        </OptionCard>
                    </el-col>
                    <el-col :span="12" class="not_table_border">
                        <OptionCard  hide-header :actions="[]" :body-style="{padding: 0}">
                            <gj-table
                                    show-overflow
                                    highlight-hover-row
                                    :adapt-height="false"
                                    :height="340"
                                    :index="false"
                                    :loading="load.star"
                                    :data="commentBarData"
                                    :columns="COMMENT_TABLE_COLUMN"
                                    :sort-config="{trigger: 'cell'}"

                            >
                            </gj-table>
                        </OptionCard>
                    </el-col>
                </el-row>
            </OptionCard>
            <OptionCard :info="{ title: 'Review分析'}" :actions="[]" key="review-analysis" :areaLevel="2" noBorder>
                <ReviewAnalysisPanel :data="reviewData"/>
                <el-row :gutter="10" style="margin-top: 10px;">
                    <el-col :span="12">
                        <OptionCard :areaLevel="2" :info="{ title: '评论趋势' }" :body-style="{padding: '16px 0 0 0'}" :actions="[]" style="padding-left: 20px;">
                            <gj-radio-group
                                    slot="action"
                                    v-model="dateStatus"
                                    :options="DATE_OPTIONS"
                                    @change="postCommentAnalysis">
                            </gj-radio-group>
                            <el-row v-loading="load.review">
                                <ve-histogram height="300px" :data-empty="commentChartData.empty" :data="commentChartData.data" :settings="commentChartData.settings" :extend="commentChartData.options" key="commentChartData"></ve-histogram>
                            </el-row>
                        </OptionCard>
                    </el-col>
                    <el-col :span="12">
                        <OptionCard :info="{ title: '星级分布' }" :areaLevel="2" :actions="[]" :body-style="{padding: '16px 0 0 0'}" style="padding-left: 20px;">
                            <el-row v-loading="load.bar">
                                <ve-bar height="300px" :data-empty="levelChartData.empty" :data="levelChartData.data" :settings="levelChartData.settings" :extend="levelChartData.options"></ve-bar>
                            </el-row>
                        </OptionCard>
                    </el-col>
                </el-row>
<!--                <OptionCard-->
<!--                        :info="{ title: '词云分析' }"-->
<!--                        :actions="[]"-->
<!--                        :areaLevel="2"-->
<!--                        no-border-->
<!--                        :body-style="{padding: 0}"-->
<!--                        style="margin-top: 10px"-->
<!--                >-->
<!--                    <gj-button type="ghost" slot="action" @click="handleFilterReviewKeywords">过滤常用词</gj-button>-->
<!--                    <el-row :gutter="10">-->
<!--                        <el-col :span="8">-->
<!--                            <div class="review-analysis-wordcloud__count">-->
<!--                                <span class="keyword">词云关键词数：</span>-->
<!--                                <span>{{ wordCloudCount }}</span>-->
<!--                            </div>-->
<!--                            <gj-table-->
<!--                                    show-overflow-->
<!--                                    highlight-hover-row-->
<!--                                    :index="false"-->
<!--                                    :loading="load.wordCloud"-->
<!--                                    :data="wordCloudTableData"-->
<!--                                    :columns="WORD_CLOUD_TABLE_COLUMN"-->
<!--                                    :sort-config="{trigger: 'cell'}"-->
<!--                                    :adapt-height="false"-->
<!--                                    :height="312"-->
<!--                                    @page-change="postWordRanked">-->
<!--                            </gj-table>-->
<!--                        </el-col>-->
<!--                        <el-col :span="16" v-loading="load.wordcloud">-->
<!--                            <ve-wordcloud height="332px" :data-empty="wordCloudChartData.empty" :data="wordCloudChartData.data" :settings="wordCloudChartData.settings" :extend="wordCloudChartData.options"></ve-wordcloud>-->
<!--                        </el-col>-->
<!--                    </el-row>-->
<!--                    <gj-table-->
<!--                        show-overflow-->
<!--                        highlight-hover-row-->
<!--                        :index="false"-->
<!--                        :loading="loading"-->
<!--                        :data="reviewTableData"-->
<!--                        :columns="REVIEW_TABLE_COLUMN"-->
<!--                        :sort-config="{trigger: 'cell'}"-->
<!--                        :adapt-height="false"-->
<!--                        :pagination="pagination"-->
<!--                        :height="400"-->
<!--                        @page-change="postReviewList">-->
<!--                        <template v-slot:star="{ row }">-->
<!--                            <el-rate disabled v-model="row.star"></el-rate>-->
<!--                        </template>-->
<!--                        <template v-slot:reviewContent="{ row }">-->
<!--                            <gj-tooltip-->
<!--                                :text-line="2"-->
<!--                                :content="row.content">-->
<!--                                {{row.content | defaultShow}}-->
<!--                            </gj-tooltip>-->
<!--                        </template>-->
<!--                        <template v-slot:amazonUserName="{ row }">-->
<!--                            <gj-badge :hidden="!row.verified" value="VP" />-->
<!--                            <span>{{ row.amazonUserName }}</span>-->
<!--                        </template>-->
<!--                        <template v-slot:orderIds="{ row }">-->
<!--                            <template v-if="row.orderIdList && row.orderIdList.length > 0">-->
<!--                                <gj-tooltip>-->
<!--                                    <div>-->
<!--                                        <gj-link @click="openOrderDetail(row)">{{ row.orderIdList[0] }}</gj-link>-->
<!--                                        <gj-icon class="el-icon-arrow-down" style="margin-left: 4px;"></gj-icon>-->
<!--                                        <gj-copy-icon v-if="isMeaningful(row.orderIdList[0])" :content="row.orderIdList[0]"/>-->
<!--                                    </div>-->
<!--                                    <template #content>-->
<!--                                        <div v-for="(orderId, index) in row.orderIdList"-->
<!--                                             :key="index">-->
<!--                                            {{orderId}}-->
<!--                                        </div>-->
<!--                                    </template>-->
<!--                                </gj-tooltip>-->
<!--                            </template>-->
<!--                            <template v-else>-</template>-->
<!--                        </template>-->
<!--                        <template v-slot:status="{ row }">-->
<!--                            <template v-if="$permission('review:edit')">-->
<!--                                <gj-select-->
<!--                                    v-model="row.status"-->
<!--                                    :clearable="false"-->
<!--                                    @input="editStatus(row.id, row.status)"-->
<!--                                    :options="reviewStatusOption">-->
<!--                                </gj-select>-->
<!--                            </template>-->
<!--                            <template v-else>-->
<!--                                {{row.status | optionText(reviewStatusOption)}}-->
<!--                            </template>-->
<!--                        </template>-->
<!--                        <template v-slot:op="{ row }">-->
<!--                            <gj-button type="text" @click="openDetail(row.id)">详情</gj-button>-->
<!--                            <gj-button type="text" @click="openLog(row.id)">日志</gj-button>-->
<!--                        </template>-->
<!--                    </gj-table>-->
<!--                </OptionCard>-->
            </OptionCard>
        </OptionCard>
    </div>
</template>

<script>

    import {
        postReviewAnalysis,
        postCommentAnalysis,
        postCommentBarAnalysis,
        postLevelAnalysis,
        postReviewList,
        postWordRanked,
        getKeywords,
        postKeywords
    } from '@/api/statistics'
    import { editReviewStatus } from "@/api/sale";
    import {
        DATE_OPTIONS,
        reviewStatusOption
    } from '@/utils/options'
    import {
        DEFAULT_CHARTS_DATA,
        COMMENT_TABLE_COLUMN,
        REVIEW_TABLE_COLUMN,
        WORD_CLOUD_TABLE_COLUMN
    } from 'modules/statistics/asin-361-analysis/config'

    import MaxStack from '@/utils/max-stack'

    import { mapGetters } from "vuex";
    import { isMeaningful } from "@/utils/common";
    import {
        responseMixin,
        queryMixin
    } from '@/minxins'

    import OptionCard from 'components/option-card/option-card'
    import ReviewAnalysisPanel from "./review-analysis-panel.vue"
    import AppReviewDetail from "components/review-modal/review-detail-modal"
    import SaleOrderDetail from "modules/sale/saleOrder/modal/sale-order-detail"
    import FilterWord from 'components/filter-word/filter-word'

    export default {
        name: "statistics-review-analysis",
        inject: ['getPageParams', 'generatorPageParams'],
        mixins: [responseMixin, queryMixin],
        data () {
            return {
                reviewData: {}, // review分析顶部panel数据
                reviewTableData: [],
                commentData: [], // 评论趋势数据
                commentBarData: [], // 评星分析数据
                levelData: [], // 星级分布数据
                wordCloudData: [], // 词云数据
                wordCloudCount: 0,
                dateStatus: 'DAY',
                DATE_OPTIONS: DATE_OPTIONS.filter(v => v.id !== 'HOURS'),
                reviewStatusOption,
                COMMENT_TABLE_COLUMN,
                REVIEW_TABLE_COLUMN: REVIEW_TABLE_COLUMN(this),
                WORD_CLOUD_TABLE_COLUMN,
                isMeaningful,
                load: {
                    star: false,
                    review: false,
                    bar: false,
                    wordCloud: false
                }
            }
        },
        components: {
            OptionCard,
            ReviewAnalysisPanel
        },
        created () {
            this.postLevelAnalysis()
            this.postReviewAnalysis()
            this.postCommentAnalysis()
            this.postCommentBarAnalysis()
            this.postReviewList()
            // this.postWordRanked()
        },
        computed: {
            ...mapGetters([
                'marketOption'
            ]),
            pageParams() {
                return this.getPageParams()
            },
            commentChartData ({ commentData = [] }) {
                if (!commentData.length) return DEFAULT_CHARTS_DATA
                let columns = ['date', 'goodReview', 'noReview', 'noReviewRate',]
                let rows = commentData.map(v => ({
                    'date': v.date,
                    'goodReview': v.goodReview,
                    'noReview': v.noReview,
                    'noReviewRate': parseFloat(v.noReviewRate / 100),
                }))

                return {
                    data: {
                        rows,
                        columns,
                    },
                    settings: {
                        labelMap: {
                            date: '日期',
                            goodReview: '好评数',
                            noReview: '中差评数',
                            noReviewRate: '中差评率'
                        },
                        stack: {
                            xxx: [
                                'goodReview',
                                'noReview'
                            ]
                        },
                        yAxisName: [
                            "评论数",
                            "中差评率"
                        ],
                        yAxisType: [
                            'normal',
                            'percent'
                        ],
                        showLine: [
                            "noReviewRate"
                        ],
                        axisSite: {
                            right: ['noReviewRate']
                        }
                    },
                    options: {
                        color: ['#1F6EEF', '#31E26C', '#CDDDFD'],
                        legend: {
                            top: '0%',
                            itemGap: 10,
                            icon: "rect",
                            itemWidth: 15,
                            itemHeight: 3,
                            textStyle: {
                                color: '#888',
                                padding: [2, 0, 0, 0],
                            }
                        },
                        grid: {
                            top: '10%',
                            left: '20px',
                            right: '20px',
                            bottom: '20px',
                            containLabel: true
                        },
                        series: {
                            barMaxWidth: 30
                        }
                    },
                    empty: !rows.length
                }
            },
            commentBarChartData ({ commentBarData = [] }) {
                if (!commentBarData.length) return DEFAULT_CHARTS_DATA
                let columns = ['date', 'oneStar', 'twoStar', 'threeStar', 'fourStar', 'fiveStar', 'star']
                let rows = commentBarData.map(v => ({
                    'date': v.date,
                    'oneStar': v.oneStar,
                    'twoStar': v.twoStar,
                    'threeStar': v.threeStar,
                    'fourStar': v.fourStar,
                    'fiveStar': v.fiveStar,
                    'star': v.star
                }))
              let dataMax = new MaxStack();
              for (let item of rows) {
                let number = 0;
                Object.keys(item).forEach(v => {
                  if (v !== 'date' && v !== 'star') {
                    number += item[v] ? parseFloat(item[v]) : 0
                  }
                })
                dataMax.push(number)
              }
                return {
                    data: {
                        rows,
                        columns
                    },
                    settings: {
                        stack: {
                            xxx: [
                                'oneStar',
                                'twoStar',
                                'threeStar',
                                'fourStar',
                                'fiveStar'
                            ]
                        },
                        labelMap: {
                            'date': '日期',
                            'oneStar': '1星',
                            'twoStar': '2星',
                            'threeStar': '3星',
                            'fourStar': '4星',
                            'fiveStar': '5星',
                            'star': '评分'
                        },
                        showLine: ['star'],
                        min: [0, 0],
                        max: ['dataMax', 'dataMax'],
                        yAxisType: [
                            'normal',
                            'normal'
                        ],
                        axisSite: {
                            right: ['star']
                        }
                    },
                    options: {
                      yAxis: (item) => {
                        item[0].splitNumber = 5
                        item[0].interval = Math.ceil(dataMax.getMax() / 5)
                        item[0].min = 0
                        item[0].max = dataMax.getMax()
                        item[1].splitNumber = 5
                        item[1].interval = 1
                        item[1].min = 0
                        item[1].max = 5
                        return item
                      },
                        legend: {
                            top: '0%',
                            itemGap: 10,
                            icon: "rect",
                            itemWidth: 15,
                            itemHeight: 3,
                            textStyle: {
                                color: '#888',
                                padding: [2, 0, 0, 0],
                            }
                        },
                        grid: {
                            top: '10%',
                            left: '15px',
                            right: '30px',
                            bottom: '0%',
                            containLabel: true
                        },

                    },
                    empty: !rows.length
                }
            },
            levelChartData ({ levelData = [] }) {
                if (!levelData.length) return DEFAULT_CHARTS_DATA
                let columns = ['starName', 'number']
                let rows = levelData.map(v => ({
                    'starName': v.starName,
                    'number': v.number,
                    'proportion': v.proportion
                }))

                let max = 0
                rows.forEach(v => {
                    max = v.number > max ? v.number : max
                })

                return {
                    data: {
                        rows,
                        columns,
                    },
                    settings: {
                        labelMap: {
                            starName: '级别',
                            number: '评论数'
                        }
                    },
                    options: {
                        color: ['#1F6EEF'],
                        series: {
                            label: {
                                show: true,
                                position: 'right',
                                valueAnimation: true,
                                formatter(params) {
                                    let { dataIndex = 0 } = params
                                    return `${rows[dataIndex].proportion || 0}%`
                                }
                            },
                            barMaxWidth: 30
                        },
                        legend: {
                            top: '0%',
                        },
                        grid: {
                            top: '30px',
                            left: '6px',
                            right: '30px',
                            bottom: '0',
                            containLabel: true
                        },
                        xAxis: {
                            position: 'bottom',
                            min: 0,
                            max: max + Math.ceil(max / 4)
                        }
                    },
                    empty: !rows.length
                }
            },
            wordCloudChartData ({ wordCloudData = [] }) {
                if (!wordCloudData.length) return DEFAULT_CHARTS_DATA
                const columns = ['word', 'count']
                const rows = wordCloudData.map(({
                    word = '',
                    count = 0
                }) => ({
                    word,
                    count
                }))

                return {
                    data: {
                        rows,
                        columns
                    },
                    settings: {

                    },
                    options: {},
                    empty: !rows.length
                }
            },
            wordCloudTableData ({ wordCloudData = [] }) {
                return wordCloudData.length <= 20 ? wordCloudData : wordCloudData.slice(0, 20)
            }
        },
        methods: {
            /**
             * 获取词云排行榜
             */
            postWordRanked () {
                const params = this.generatorPageParams(this.pageParams)
                this.load.wordcloud = false
                postWordRanked(params).then(({ count = 0, wordCouldRankedVOList: wordCloudData = []}) => {
                    this.wordCloudCount = count
                    this.wordCloudData = wordCloudData.map(({ranking = '', word = '', count = 0}) => ({ ranking, word, count }))
                }).complete(() => this.load.wordcloud = false)
            },
            /**
             * 获取review统计数据
             */
            postReviewAnalysis () {
                let params = this.generatorPageParams(this.pageParams)
                postReviewAnalysis(params).then(res => {
                    this.reviewData = Object.assign({}, this.reviewData, res)
                })
            },
            /**
             * 获取review列表数据
             */
            postReviewList () {
                let model = this.generatorPageParams(this.pageParams)
                let params = {
                    model,
                    ...this.queryPagination
                }
                postReviewList(params).then(data => {
                    this.reviewTableData = data.records || []
                    this.pagination = this.getPagination(data);
                }).complete(() => this.loading = false)
            },
            /**
             * 获取评论趋势
             */
            postCommentAnalysis () {
                let params = this.generatorPageParams(this.pageParams)
                params.viewType = this.dateStatus
                this.load.review = true
                postCommentAnalysis(params).then((res = []) => {
                    this.commentData = res
                }).complete(() => {
                    this.load.review = false
                })
            },
            /**
             * 评星分析
             */
            postCommentBarAnalysis () {
                let params = this.generatorPageParams(this.pageParams)
                this.load.star = true
                postCommentBarAnalysis(params).then((res = []) => {
                    this.commentBarData = res.reverse();
                }).complete(() => this.load.star = false)
            },
            /**
             * 获取星级分布数据
             */
            postLevelAnalysis () {
                let params = this.generatorPageParams(this.pageParams)
                this.load.bar = true
                postLevelAnalysis(params).then((res = []) => {
                    this.levelData = res
                }).complete(() => this.load.bar = false)
            },
            /**
             * review详情
             */
            openDetail(id) {
                this.$gjCreate(AppReviewDetail, {
                    props: {
                        id: id,
                    }
                })
            },
            /**
             * review Log
             */
            openLog(id) {
                this.$gjCreate('gj-log-modal', {
                    props: {
                        url: '/crm/review/' + id + '/logs',
                    }
                });
            },
            /**
             * 订单详情
             */
            openOrderDetail(row) {
                this.$gjCreate(SaleOrderDetail, {
                    props: {
                        orderId: row.orderIds[0],
                        marketId: row.marketId
                    }
                })
            },
            /**
             * 编辑review状态
             */
            editStatus(id, status) {
                editReviewStatus(id, status)
                    .then((res) => {
                        this.$gjResponseHandle(res, () => {
                            this.$gjMessage.success('更新成功');
                            this.$gjResetPage();
                        });
                    })
            },
            /**
             * 过滤常用词
             */
            handleFilterReviewKeywords () {
                const params = this.generatorPageParams(this.pageParams)
                const fnView = getKeywords.bind(null, params)
                const fnUpdate = postKeywords
                const modal = this.$gjCreate(FilterWord, {
                    props: {
                        fnView,
                        fnUpdate
                    },
                    on: {
                        complete: () => {
                            this.postWordRanked()
                        }
                    }
                })
            },
            /**
             * 区域数据刷新
             */
            refresh () {
                this.postLevelAnalysis()
                this.postReviewAnalysis()
                this.postCommentAnalysis()
                this.postCommentBarAnalysis()
                this.postReviewList()
                // this.postWordRanked()
            }
        },
    }
</script>

<style lang="scss" scoped>
    .not_table_border{
        /deep/ .vxe-table--border-line{
            border: none;
        }
    }
    .review-analysis {
        &-wordcloud__count {
            font-size: 14px;
            .keyword {
                color: #666666;

            }

            .count {
                font-weight: bold;
            }
        }
    }
</style>
